import i18n from '@/utils/i18n';
import Axios, { AxiosError, AxiosRequestConfig, AxiosResponse } from 'axios';

const onResponse = (response: AxiosResponse): AxiosResponse => {
    const data = response.data;
    if ((data?.code === 80007000)) {
        console.log('[onResponse] caught restricted response:', data);
        localStorage.removeItem('token');
        sessionStorage.removeItem('user');
        window.location.href = '/auth/access-restricted';
    }
    return response;
}

const onResponseError = (error: AxiosError): Promise<AxiosError> => {
    console.error('[response error]', error.message, error.response?.data);
    if ((error.response?.data as any)?.code === 80007000) {
        console.log('[403 response data]', error.response?.data);
        localStorage.removeItem('token');
        sessionStorage.removeItem('user');
        window.location.href = '/auth/access-restricted';
    }
    return Promise.reject(error);
}

export const AxiosInstance = Axios.create({
  baseURL: import.meta.env.VITE_API_BASE,
  paramsSerializer: (params) => {
    return Object.entries(params)
      .map(([key, value]) => {
        if (Array.isArray(value)) {
          return `${key}=${value.join(',')}`;
        }
        return `${key}=${value}`;
      })
      .join('&');
  },
});

AxiosInstance.interceptors.response.use(onResponse, onResponseError);
AxiosInstance.interceptors.request.use(
  (config) => {
    // 从 i18n 获取当前语言（如 'zh-CN'、'en-US'）
    const currentLanguage = i18n.language || 'zh-HK';
    
    // 设置 Accept-Language 请求头
    if (currentLanguage) {
      config.headers['Accept-Language'] = currentLanguage;
    }
    
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export const customInstance = <T>(
    config: AxiosRequestConfig,
    options?: AxiosRequestConfig,
  ): Promise<T> => {
    const source = Axios.CancelToken.source();
    const token = localStorage.getItem('token');
    if (token) {
        config.headers = {
            ...config.headers,
            Authorization: `Bearer ${token}`,
        };
    }
    config.headers = {
      ...config.headers,
      ...options?.headers,
    };
    
    const promise = AxiosInstance({
      ...config,
      cancelToken: source.token,
    }).then(({ data }) => data);
  
    // @ts-ignore
    promise.cancel = () => {
      source.cancel('Query was cancelled');
    };
  
    return promise;
  };

// TODO: request through network
export const BASE_QUESTION_IMAGE_URL = import.meta.env.VITE_API_BASE + '/images/question/';
export const BASE_ANSWER_IMAGE_URL = import.meta.env.VITE_API_BASE + '/images/answer/';